const legalType = [{id: '', name: '全部'},{id: 1, name: '合法', type: 'success'},{id: 2, name: '非法', type: 'danger'},{id: 3, name: '应急', type: 'warning'}];
const projectType  = [{id: '', name: '全部'},{id: 1, name: '绿化工程'},{id: 2, name: '市政工程'},{id: 3, name: '景观照明工程'},{id: 4, name: '城市排水工程'}];
const projectSchedule = [{id: '', name: '全部'},{id: 1, name: '0%'},{id: 2, name: '25%'},{id: 3, name: '50%'},{id: 4, name: '75%'},{id: 5, name: '100%'}];
const constructionStage = [{id: '', name:'全部'},{id: 1, name: '施工前'},{id: 2, name: '施工中'}, {id: 3, name: '已竣工但未验收'},{id: 4, name: '已验收'},{id: 5, name: '养护阶段'},{id: 6, name: '交接归档'}];
// 占用类型
const impermanency = [{id: '', name: '全部'},{id: 1, name: '永久', type: 'success'},{id: 2, name: '临时', type: 'danger'}];
//是否延期
const isDelay = [{id: '', name: '全部'},{id: 1, name: '未延期'},{id: 2, name: '已延期'}];
// 是否归档
const archive = [{id: '', name: '全部'},{id: 1, name: '未归档'},{id: 2, name: '已归档'}];
export default {
    legalType,
    projectType,
    projectSchedule,
    constructionStage,
    impermanency,
    isDelay,
    archive
}

export {
    legalType,
    projectType,
    projectSchedule,
    constructionStage,
    impermanency,
    isDelay,
    archive
}


// WEBPACK FOOTER //
// ./src/page/maintenance/config/projectOption.js